import axios from 'axios';
import { GET_JOBS_BY_PROPERTY } from '../../constants';

export const fetchJobsByProperty = (pId, onError) => (dispatch) => {
  const token = localStorage.jwtToken;
  const config = {
    headers: { Authorization: `Bearer ${token}` },
  };
  dispatch(loadJobsByProperty());

  axios
    .get(`/client/getJobsByProperty?propertyId=${pId}`, config)
    .then((res) => dispatch(setJobsByProperty(res)))
    .catch((err) => {
      dispatch(errorJobsByProperty(err.response));
      onError(err.response);
    });
};

export const loadJobsByProperty = () => ({
  type: GET_JOBS_BY_PROPERTY.LOAD,
});

export const setJobsByProperty = (jobList) => ({
  type: GET_JOBS_BY_PROPERTY.SUCCESS,
  payload: jobList.data.data,
});

export const errorJobsByProperty = (error) => ({
  type: GET_JOBS_BY_PROPERTY.FAIL,
  payload: error,
});
